<div class="content">
  <h1>Dashboard</h1>
</div>